import { render, staticRenderFns } from "./TextOneCol.vue?vue&type=template&id=494f7cd2&scoped=true&"
import script from "./TextOneCol.vue?vue&type=script&lang=js&"
export * from "./TextOneCol.vue?vue&type=script&lang=js&"
import style0 from "./TextOneCol.vue?vue&type=style&index=0&id=494f7cd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494f7cd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCol,VContainer,VImg,VProgressCircular,VRow,VSheet})
